// extracted by mini-css-extract-plugin
module.exports =  {"main":"qX1UtW1"};